import React from 'react';
import MaintenanceGuides from 'src/components/MaintenanceGuides/MaintenanceGuides';
import LoadState from 'src/components/LoadState/LoadState';
import { MaintenanceGuide } from 'src/SharedCustomHooks/UseMaintenanceGuides/types';

interface SuiteMaintainenceGuideProps {
  maintenanceGuides: MaintenanceGuide[];
  loading: boolean;
  error: any;
  setSearchTerm: (term: string) => void;
  searchTerm: string
}

const SuiteMaintainenceGuide = ({
  maintenanceGuides,
  loading,
  error,
  setSearchTerm,
  searchTerm
}: SuiteMaintainenceGuideProps) => {
  if (error) {
    return (
      <div className="error-state">
        <p>Failed to load maintenance reminders.</p>
        <button onClick={() => window.location.reload()}>Try Again</button>
      </div>
    );
  }

  return (
    <LoadState isLoading={loading}>
      <MaintenanceGuides
        maintenanceguides={maintenanceGuides}
        onlyView={true}
        onSearch={(e: any) => setSearchTerm(e.target.value.trim())}
        introContent={true}
        from={undefined}
        onSaveMaintenanceGuide={undefined}
        onDeleteNote={undefined}
        breadcrumb={undefined}
        searchTerm={searchTerm}
      />
    </LoadState>
  );
};

export default SuiteMaintainenceGuide;
